import { render, staticRenderFns } from "./DragAndDropBuildFractions.vue?vue&type=template&id=0bf90fdd&scoped=true&"
import script from "./DragAndDropBuildFractions.vue?vue&type=script&lang=ts&"
export * from "./DragAndDropBuildFractions.vue?vue&type=script&lang=ts&"
import style0 from "./DragAndDropBuildFractions.vue?vue&type=style&index=0&id=0bf90fdd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf90fdd",
  null
  
)

export default component.exports